<script>
  export let content = '';
</script>

<div class="container">
  <div class="icon-wrapper"></div>

  <div class="box-texto">
    {@html content}
  </div>
</div>

<style>
  .container {
    --Principais-Roxo-azul: #8421e9;
    --transparentes-roxo-10: rgba(132, 33, 233, 0.1);
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;

    position: relative;
    margin-top: 16px;
    /*margin-bottom: 30px;*/
  }

  .icon-wrapper {
    position: absolute;
    top: -16px;
    /* transform: translateY(-15%); */
    left: -32px;
    z-index: 10;
    /* display: flex; */
    /* align-items: center; */
    /* justify-content: center; */
  }

  .icon-wrapper svg {
    /* width: 68px; */
    /* height: 72px; */
  }

  .box-texto :global(b) {
    font-size: 17px;
    display: block;
    margin-bottom: 0.5em;
  }
  .box-texto {
    width: 100%;
    height: auto;

    color: var(--PRETO);
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 25px 30px 25px 29px;
    white-space: pre-wrap;
    word-break: break-word;

    border: 2px solid var(--MARROM);
    background-color: var(--MARROM_SUPER_CLARO);

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    background-color: var(--COR_MOD_PRI_BOAS_1);
    padding: 6px 15px 6px 60px;
    border-radius: 12.7px 8.7px 8.7px 0px;
  }

  .titulo h2 {
    color: var(--Principais-Branco, #fff);
    font-family: var(--FONT_ARCHI);
    font-size: 24px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0em;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: -1px;
      transform: translateY(0px);
      left: 5px;
    }

    .icon-wrapper svg {
      width: 50px;
      height: unset;
    }
    .titulo {
      padding: 7px 15px 7px 50px;
      border-radius: 28px 8.7px 8.7px 0px;
      top: 18px;
      position: relative;
    }
    .box-texto {
      padding: 20px 20px 15px 20px;
      margin-top: 18px;
    }
  }
</style>
